/* eslint-disable unicorn/filename-case */
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/corpdrivee/_sidebar-layout/ride-orders/$id')({
    onEnter: (context) => {
        document.title = `CorpDrivee - Заказ №${context.params.id}`
    },
})
